<template>
  <div
    :class="[priceTableStore.popupOpen ? 'translate-y-0' : 'translate-y-full']"
    class="fixed inset-0 z-50 flex h-full w-full flex-col justify-between bg-white transition-transform duration-500 md:hidden"
  >
    <div>
      <div
        class="mb-5 flex items-center justify-between border-b border-gray-lightest p-4"
      >
        <h4 class="text-center text-[22px] font-bold">
          {{ $t('general.price_table.filters.title') }}
        </h4>

        <button
          type="button"
          class="flex h-8 w-8 items-center justify-center"
          @click="priceTableStore.togglePriceFilterPopup(false)"
        >
          <FontAwesomeIcon
            :icon="{ prefix: 'fas', iconName: 'times' }"
            class="text-xl text-gray transition duration-200 ease-in-out hover:text-black"
          />
        </button>
      </div>
      <div
        v-if="priceTableStore.hasFilters"
        class="flex w-full flex-col items-center gap-3"
      >
        <div class="w-full px-5">
          <FilterDropdown
            v-model="
              priceTableStore.selectedFilterOptions[
                priceTableStore.firstFilterKey
              ]
            "
            :index="priceTableStore.firstFilterKey"
            :label="priceTableStore.firstFilterValue?.meta?.name"
            :options="priceTableStore.firstFilterOptions"
            :show-predefined-show-text="false"
          />
        </div>

        <div
          v-for="(filter, index) in priceTableStore.otherFilters"
          :key="`filter_${index}`"
          class="w-full px-5"
        >
          <div class="w-full">
            <FilterDropdown
              v-model="priceTableStore.selectedFilterOptions[index]"
              :index="index"
              :label="filter.meta.name"
              :options="priceTableStore.filterOptions[index]"
              :show-predefined-show-text="false"
              :disabled="priceTableStore.isFavoriteOptionSelected"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="shrink-0 px-4 pb-4">
      <DefaultButton @click="priceTableStore.togglePriceFilterPopup">
        {{ $t('general.price_table.filters.apply_button.label') }}
      </DefaultButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import DefaultButton from '@/components/Buttons/DefaultButton.vue';
import FilterDropdown from '@/pages/ProductPage/partials/ProductFilters/FilterDropdown.vue';
import { usePriceTableStore } from '@/stores/PriceTable/PriceTableStore.ts';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

const priceTableStore = usePriceTableStore();
</script>
